import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PaginationState {
  page: number
  rowsPerPage: number
}

interface TablePaginationState {
  [tableKey: string]: PaginationState
}

const initialState: TablePaginationState = {}

const tablePaginationSlice = createSlice({
  name: 'tablePagination',
  initialState,
  reducers: {
    setTablePagination: (
      state,
      action: PayloadAction<{
        tableKey: string
        page: number
        rowsPerPage: number
      }>
    ) => {
      const { tableKey, page, rowsPerPage } = action.payload
      state[tableKey] = { page, rowsPerPage }
    },
    resetTablePagination: (state, action: PayloadAction<string>) => {
      delete state[action.payload]
    },
  },
})

export const { setTablePagination, resetTablePagination } =
  tablePaginationSlice.actions
export default tablePaginationSlice.reducer
